export default __webpack_public_path__ + "static/media/citrus-slurricane-sour.7e060d97.png";